/**
 * Shoulder-tap service health, tracked internally.
 *
 * Health used to travel to the embedding host on the `service-health-changed`
 * bridge event so the host could render an "unavailable" indicator. That event
 * has been removed: health is now an internal signal only, reported as a
 * frontend metric on each flip.
 */

import { METRICS_EVENTS } from '../constants';

export type ServiceHealthStatus = 'offline' | 'healthy';

/**
 * The metric to emit for a status observation, or `null` when the observation
 * isn't a flip and nothing should be emitted.
 *
 * `previous === null` means we have no prior observation for this contact.
 * Starting out offline is worth reporting; starting out healthy is the expected
 * baseline, so it's silent — otherwise every contact would emit a "recovered"
 * it never recovered from.
 */
export const serviceHealthMetricForTransition = (
  previous: ServiceHealthStatus | null,
  next: ServiceHealthStatus,
): string | null => {
  if (previous === next) return null;
  if (next === 'offline') return METRICS_EVENTS.SERVICE_HEALTH_OFFLINE;
  return previous === 'offline' ? METRICS_EVENTS.SERVICE_HEALTH_RECOVERED : null;
};
